import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const BlockHistoryPage = styled.div`
  .button-group {
    float: right;
    clear: both;
  }
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }  
  .ant-table-wrapper {
    min-width: 100%;
  }
  .delete-button{
    margin-left:8px;
  }

  .card_content{
    display:inline;
  }

  .card_value{
    float:right;
  }
  ul.ant-timeline{
    padding-top:0.5rem;
    min-height: 100px !important;
    max-height : 600px  !important;
    padding-right: 1rem !important;
    scrollbar-color: #DDDDDD transparent !important;
    overflow-y: auto !important;
    scrollbar-width: thin !important;
}
.ant-timeline-item-content > p {
  font-size: 12px !important;
    font-weight: 600!important;
    line-height: 24px!important;
    -webkit-letter-spacing: 0em!important;
    letter-spacing: 0em!important;
    color: #000000!important;
    margin-bottom: 10px!important;
}
.ant-card.ant-card-bordered{
    border-radius: 8px;
    display: inline-block;
    width: 100%;
}
.edit-cust{
    color: #0B2A1B !important; 
    margin-right: 20px !important; 
    float:right !important;
}
.dlt-cust{
    color:red !important; 
    marginRight: 20px !important;
    float:right !important;
}

.wrap-card-activity{
    position:relative;
  }
  .btn-edit-activity{
    color: #0B2A1B;
  }
  .btn-delete-activity{
    color: red;
  }
  .card-activity-title{
    text-transform: capitalize;
    margin-bottom: 20px;
  }

  a,.ant-btn:hover{
    border-color: #0B2A1B;
    color:#0B2A1B
  }
  
  .attachment-activity{
    text-transform: none;
    color: #0B2A1B;
  }
  .wrap-btn-activity {
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 1;
  }
`;

export default WithDirection(BlockHistoryPage);